var map = {
	"./modules/about/about.module": [
		"./src/app/modules/about/about.module.ts",
		"modules-about-about-module"
	],
	"./modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts"
	],
	"./modules/checkprice/achats/achats.module": [
		"./src/app/modules/checkprice/achats/achats.module.ts",
		"modules-checkprice-achats-achats-module"
	],
	"./modules/checkprice/availibility/availibility.module": [
		"./src/app/modules/checkprice/availibility/availibility.module.ts",
		"modules-checkprice-availibility-availibility-module"
	],
	"./modules/checkprice/recap/recap.module": [
		"./src/app/modules/checkprice/recap/recap.module.ts",
		"modules-checkprice-recap-recap-module"
	],
	"./modules/checkprice/viewresa/view-resa.module": [
		"./src/app/modules/checkprice/viewresa/view-resa.module.ts",
		"modules-checkprice-viewresa-view-resa-module"
	],
	"./modules/contact/contact.module": [
		"./src/app/modules/contact/contact.module.ts",
		"modules-contact-contact-module"
	],
	"./modules/home/home.module": [
		"./src/app/modules/home/home.module.ts",
		"modules-home-home-module"
	],
	"./modules/manager/list/list.module": [
		"./src/app/modules/manager/list/list.module.ts",
		"modules-manager-list-list-module"
	],
	"./modules/manager/resa/resa.module": [
		"./src/app/modules/manager/resa/resa.module.ts",
		"modules-manager-resa-resa-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;